import { campaign } from '@/json/json_loader';

export const LS_TRACKING_ID = `${campaign.campaignUuid}:trackingId`;
export const LS_KEY_SURVEY = `${campaign.campaignUuid}:survey`;
